import { get } from 'config';

export const ELIGIBILITY_COMPASS_ENABLED_ENDPOINT = '/admin/eligibility-compass/enabled';

/**
 * Response shape returned by the ResidentVerify Eligibility Compass status
 * endpoint. `errors` is always an array in the API contract — the server maps
 * missing/invalid arrays to `[]` — so consumers can iterate it unconditionally.
 */
export interface EligibilityCompassStatusResponse {
  isEnabled: boolean;
  errors: string[];
}

export async function getEligibilityCompassStatus(
  clientId: number,
  propertyId: number,
): Promise<EligibilityCompassStatusResponse> {
  const response = await get(`${ELIGIBILITY_COMPASS_ENABLED_ENDPOINT}/${clientId}/${propertyId}`);

  return response.data;
}
